import { type ComponentProps } from "react";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { MorphemeTranscription as MorphemeTranscriptionValue } from "@-/dev.improve.haniverse.lib.morpheme.transcription.entities";

type MorphemeTranscriptionProps = Omit<ComponentProps<typeof Text>, "children"> & {
  transcription: MorphemeTranscriptionValue;
};

export function MorphemeTranscription({
  className,
  style,
  transcription,
  ...props
}: MorphemeTranscriptionProps) {
  return (
    <Text
      className={className}
      style={[{ color: transcription.color ?? "#000000" }, style]}
      {...props}
    >
      {transcription.pinyin}
    </Text>
  );
}
